import BaseService from "../baseService";
class ConsultaPercentual extends BaseService {
  constructor(id) {
    const resource = "consulta-percentual-rateio-padrao";
    let relationship = {};
    super(id, relationship, resource);
  }
}

export default (id) => new ConsultaPercentual(id);
